const formatTextToHTML = (text: string) => {
  const bold = /\*(.+)\*/g; // find whatsapp bold text https://regex101.com/r/Lruxej/2
  const italic = /_(.+)_/g; // find whatsapp italic text https://regex101.com/r/Nduwbw/2
  const strike = /~(.+)~/g; // find whatsapp strike text https://regex101.com/r/jb0Tfi/2
  const monospace = /```(.+)```/g; // find whatsapp monospace text https://regex101.com/r/lu6qDK/1
  const quote = /> (.+)/; // find whatsapp quote text https://regex101.com/r/9CmBUM/1
  const inlineCode = /(?<!```)`([^`]+)`(?!```)/g; // find whatsapp inline code text https://regex101.com/r/ENOIY2/1

  const formattedText = text
    .replace(quote, '<blockquote>$1</blockquote>')
    .replace(bold, '<b>$1</b>')
    .replace(italic, '<i>$1</i>')
    .replace(strike, '<s>$1</s>')
    .replace(monospace, '<code>$1</code>')
    .replace(inlineCode, '<code>$1</code>');

  return formattedText;
};

export default formatTextToHTML;
